import {
  DataGrid,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React, { useContext, useEffect, useMemo, useState } from "react";
import ModuleHeader from "../../../components/headers/ModuleHeader";
import { DataGridStyle } from "../../../components/tables/DataGridStyles";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllInsuranceCompanies,
  getAllInsuranceType,
  getInsuranceTypeById,
  postInsuranceType,
  updateInsuranceCompany,
} from "../../../services/Services";
import PaginationTable from "../../../components/tables/Pagination";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DeleteConfigModal from "../DeleteConfigModal";
import Form from "../../../components/forms/Form";
import { CommonContextAPI } from "../../../App";

const CustomToolbar = () => {
  const propsData = useSelector((state) => state?.CommonData);
  const { clearAppliedFilters } = propsData;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px",
      }}
    >
      <GridToolbarQuickFilter />
      <div sx={{ "& .MuiButtonBase-root": { minWidth: "32px" } }}>
        <GridToolbarExport />
        <Button
          variant="contained"
          size="small"
          // className={classes.clearButton}
          style={{ marginLeft: "10px", backgroundColor: "blue !importent" }}
          onClick={clearAppliedFilters}
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
};

const renderForm = [
  {
    label: "Insurance Type",
    fields: [
      {
        label: "Insurance Type",
        field: "TextField",
        name: "type",
        id: "type",
        type: "text",
        grids: 12,
      },
    ],
  },
];
export default function AllInsuranceType() {
  const [isRemoveConfigModal, setIsRemoveConfigModal] = useState(false);
  const [AllCompanies, setAllCompanies] = useState([]);
  const [isEditInsuranceType, setIsEditInsuranceType] = useState(false);
  const [updateObj, setUpdateObj] = useState();
  const [isAdmin, setIsAdmin] = useState(true);

  const Navigate = useNavigate();

  const commonData = useContext(CommonContextAPI);

  const { addInsuranceType, setAddInsuranceType } = commonData;

  const AdminRole = useSelector((state) => state.AdminLogin.role);

  useEffect(() => {
    if (
      AdminRole.toLowerCase() == "super admin" ||
      AdminRole.toLowerCase() == "admin"
    ) {
      setIsAdmin(false);
    }
  }, [AdminRole]);

  function FooterSection() {
    return (
      <div className="grid-table-footer">
        <div className="grid-table-footer-right"></div>
        <PaginationTable />
      </div>
    );
  }

  const getAllCompanies = async () => {
    try {
      const request = await getAllInsuranceType();
      const response = await request.data;
      setAllCompanies(response.result);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllCompanies();
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      headerClassName: "super-app-theme--header",
      minWidth: 250,
      flex: 1,
    },

    {
      field: "type",
      headerName: "Insurance type",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 1,
    },

    {
      field: "edit",
      headerName: "Edit",
      headerClassName: "super-app-theme--header",
      editable: true,
      hide: isAdmin,
      Width: "10px",
      minWidth: 10,
      // flex: 1,
      renderCell: (params) => {
        let name = params?.row?.type?.split(" ").join("_");
        return (
          <Box
            sx={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
            }}
            onClick={() => {
              setIsEditInsuranceType(true);
              getInsuranceTypeInfo(params?.id);
            }}
          >
            <EditIcon />
          </Box>
        );
      },
    },
    {
      field: "remove",
      headerName: "Remove",
      headerClassName: "super-app-theme--header",
      editable: true,
      hide: isAdmin,
      minWidth: 10,
      renderCell: (par) => {
        return (
          <DeleteForeverIcon
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => {
              setIsRemoveConfigModal(true);
            }}
          />
        );
      },
    },
  ];
  // --- Edit Insurance Type ---------------------
  const getInsuranceTypeInfo = async (id) => {
    try {
      const request = await getInsuranceTypeById(id);
      const response = await request.data;
      setUpdateObj(response.result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdate = async () => {
    try {
      const request = await updateInsuranceCompany(updateObj);
      setIsEditInsuranceType(false);
    } catch (error) {
      console.log(error);
    }
  };

  // --- Add new Insurance Type ------

  const handleAddInsuranceType = async () => {
    try {
      const request = await postInsuranceType(updateObj);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box className="comp-container">
      <ModuleHeader heading="Insurance Types" />

      <Box className="data-grid-container">
        {isRemoveConfigModal && (
          <DeleteConfigModal
            isRemoveConfigModal={isRemoveConfigModal}
            setIsRemoveConfigModal={setIsRemoveConfigModal}
          />
        )}

        {addInsuranceType && (
          <Form
            heading="Add Insurance Type"
            closeModal={() => setAddInsuranceType(false)}
            renderForm={renderForm}
            state={updateObj}
            setState={setUpdateObj}
            submit={handleAddInsuranceType}
          />
        )}
        {isEditInsuranceType && (
          <Form
            heading="Edit Insurance Type"
            closeModal={() => setIsEditInsuranceType(false)}
            renderForm={renderForm}
            state={updateObj}
            setState={setUpdateObj}
            submit={handleUpdate}
            isEdit={true}
          />
        )}
        <DataGrid
          columns={columns}
          rows={AllCompanies}
          sx={DataGridStyle}
          components={{
            Footer: FooterSection,
            Toolbar: CustomToolbar,
          }}
          pageSize={50}
        />
      </Box>
    </Box>
  );
}
